export default __webpack_public_path__ + "static/media/promo_06.aaa2c938.jpg";